import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';

import SubscribeModal from './SubscribeModal';
import { actions as webhooksActions } from '../../../Webhooks/reducers';
import { actions as vehiclesActions, status } from '../../reducers';
import { selectors as orgSelectors } from '../../../../../../services/organizations/reducers';


const mapStateToProps = (state) => {
  const currentOrganization = orgSelectors.getCurrentOrganization(state);
  return {
    webhooks: Object.values(state.webhooks.webhooks),
    isFetchingWebhooks: state.webhooks.isFetchingWebhooks,
    isSubscribing: state.vehicles.subscribeStatus === status.PENDING,
    featureSetId: currentOrganization.featureSetId,
    rolePermissions: currentOrganization.rolePermissions,
    applicationId: state.applications.selectedApplication,
  };
};

const mapDispatchToProps = (dispatch) => {
  const { fetchWebhooksRequest } = webhooksActions;
  const { subscribeVehiclesToWebhooks } = vehiclesActions;
  return {
    actions: bindActionCreators(
      {
        fetchWebhooksRequest,
        subscribeVehiclesToWebhooks,
      },
      dispatch,
    ),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(SubscribeModal);

